// @ts-ignore
export var DEV = typeof __DEV__ !== 'undefined' && __DEV__;
export var LOCAL_PRODUCTION_BACKEND =
// @ts-ignore
typeof __LOCAL_PRODUCTION_BACKEND__ !== 'undefined' &&
// @ts-ignore
__LOCAL_PRODUCTION_BACKEND__;